interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  const baseBtn =
    'flex h-9 min-w-9 items-center justify-center rounded-md border px-3 text-sm transition-colors';

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className={`${baseBtn} border-background-300 bg-background-50 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700`}
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {start > 1 && (
        <>
          <button
            type="button"
            onClick={() => onChange(1)}
            className={`${baseBtn} border-background-300 bg-background-50 text-foreground-700 hover:border-primary-400 hover:text-primary-600`}
          >
            1
          </button>
          {start > 2 && <span className="px-1 text-foreground-400">…</span>}
        </>
      )}

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`${baseBtn} ${
            p === page
              ? 'border-primary-600 bg-primary-600 text-background-50'
              : 'border-background-300 bg-background-50 text-foreground-700 hover:border-primary-400 hover:text-primary-600'
          }`}
        >
          {p}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="px-1 text-foreground-400">…</span>}
          <button
            type="button"
            onClick={() => onChange(totalPages)}
            className={`${baseBtn} border-background-300 bg-background-50 text-foreground-700 hover:border-primary-400 hover:text-primary-600`}
          >
            {totalPages}
          </button>
        </>
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className={`${baseBtn} border-background-300 bg-background-50 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700`}
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}